// extracted by mini-css-extract-plugin
export default {"switcher":"VariantSwitcher_switcher__R1uY7"};